import { useHasAccess } from '@components/HasAccess'
import { permissionsForPath } from '@utils/routePermissions'

/**
 * Answers "may this admin open this path?" from ROUTE_PERMISSIONS — the shared
 * declaration read by both the route gate and the navigation, so a menu entry
 * can never disagree with the page it links to.
 *
 * A path with nothing declared is open: this hook gates what has been
 * declared, it does not invent gates.
 */
export const useCanAccessPath = () => {
  const { hasAccess } = useHasAccess()

  const canAccessPath = (path: string): boolean => {
    const permissions = permissionsForPath(path)

    // null: deliberately ungated. undefined: nothing declared for this path.
    if (permissions === null || permissions === undefined) return true

    return hasAccess(permissions)
  }

  return { canAccessPath }
}
